export const queryParamKeys = {
  selectedSearchGroup: 'selectedSearchGroup',
}

export const stringSeparator = '~~~'
